































































import Vue, { PropOptions } from 'vue';
import Button from '~/components/builders/Base/Button.vue';
import BillingService, {
    BillingAccount,
    PaymentMethod,
    Subscription,
} from '~/services/BillingService';
import { PaymentMethodItem } from '../types';
import { getPaymentMethodBrandLogo, getPaymentMethodBrandString } from '../util';

export default Vue.extend({
    name: 'SelectSubscriptionPaymentMethod',
    components: { Button },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
        subscription: {
            type: Object,
            required: true,
        } as PropOptions<Subscription>,
    },
    data() {
        return {
            loading: false,
            error: '' as string | null,
            service: new BillingService(),

            paymentMethods: [] as PaymentMethod[],
        };
    },
    computed: {
        paymentMethod(): PaymentMethod | null {
            return this.subscription.paymentMethod || this.billingAccount.defaultPaymentMethod;
        },
        items(): PaymentMethodItem[] {
            return this.paymentMethods.reduce<PaymentMethodItem[]>(
                (acc, pm) =>
                    !pm.card
                        ? acc
                        : [
                              ...acc,
                              {
                                  id: pm.id,
                                  logo: getPaymentMethodBrandLogo(pm.card.brand),
                                  brand: getPaymentMethodBrandString(pm.card.brand),
                                  last4: pm.card.last4,
                                  name: pm.billingDetails ? pm.billingDetails.name : 'Unknown',
                                  expiration: pm.card
                                      ? `${pm.card.expMonth}/${pm.card.expYear.toString().slice(2)}`
                                      : 'Unknown',
                                  isDefault:
                                      !!this.billingAccount.defaultPaymentMethod &&
                                      pm.id === this.billingAccount.defaultPaymentMethod.id,
                                  isSelected:
                                      !!this.paymentMethod && pm.id === this.paymentMethod.id,
                              },
                          ],
                []
            );
        },
    },
    methods: {
        getPaymentMethods() {
            this.loading = true;
            this.service
                .getPaymentMethods(this.billingAccount.id)
                .then(pms => (this.paymentMethods = pms))
                .catch(this.handleError)
                .finally(() => (this.loading = false));
        },

        handleError(err: any) {
            console.error(err);
            this.error = this.$t('errors.tryAgain').toString();
            return null;
        },

        handleSelect(item: PaymentMethodItem) {
            this.loading = true;
            this.service
                .updateDefaultPaymentMethodForSubscription(this.subscription.id, item.id)
                .then(() => this.$emit('done', true))
                .catch(this.handleError)
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.getPaymentMethods();
    },
});
